import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'

import { cn } from '@shared/lib/cn'

import MobileMenu from './menu'

import styles from './styles.module.scss'

interface BurgerProps {
  className?: string;
}

const ModalTitle = () => {
  const { t: tn } = useTranslation('navigation')
  return <>{tn('menu')}</>
}

export default function Burger (props: BurgerProps) {
  const { className } = props
  const { openModal } = useModalStore()

  return (
    <button
      type="button"
      className={cn('reset-button', className, styles.root)}
      onClick={() => {
        openModal('mobileMenu', <MobileMenu />, {
          title: <ModalTitle />,
          classes: {
            body: styles['modal-body'],
            content: styles['modal-content'],
          },
        })
      }}
    >
      {Array.from({
        length: 3,
      }).map((_, index) => {
        return <span className={styles.root__item} key={index}></span>
      })}
    </button>
  )
}
